export const AdminActions = ({show, children}) => {
    if(show) {
        return (
            <>
                {children}
            </>
        )
    }
}